/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S14_HeadingInputs */

const tr_mesafeli_s14_heading = /** @type {(inputs: Mesafeli_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Sorumluluğun Sınırlandırılması`)
};

const en_mesafeli_s14_heading = /** @type {(inputs: Mesafeli_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Limitation of Liability`)
};

const de_mesafeli_s14_heading = /** @type {(inputs: Mesafeli_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Haftungsbeschränkung`)
};

const ru_mesafeli_s14_heading = /** @type {(inputs: Mesafeli_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Ограничение ответственности`)
};

/**
* | output |
* | --- |
* | "14. Limitation of Liability" |
*
* @param {Mesafeli_S14_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s14_heading = /** @type {((inputs?: Mesafeli_S14_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S14_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s14_heading(inputs)
	if (locale === "de") return de_mesafeli_s14_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s14_heading(inputs)
	return tr_mesafeli_s14_heading(inputs)
});